import styled, { css } from 'styled-components'

export const Input = styled.input<{ bordered: boolean; error?: boolean }>`
  width: 100%;
  height: 4.4rem;
  border: 1px solid
    ${({ theme, bordered }) => (bordered ? theme.colors.border : 'transparent')};
  font-size: 14px;
  padding: 1.7rem 1.5rem;
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.fonts.brand};
  background: ${({ theme }) => theme.colors.background};
  box-sizing: border-box;
  font-weight: 500;
  line-height: 1.25rem;
  letter-spacing: 0;

  ${({ error }) => {
    return (
      error &&
      css`
        border-color: ${({ theme }) => theme.colors.danger};
      `
    )
  }}

  &::placeholder {
    opacity: 0.8;
    font-family: ${({ theme }) => theme.fonts.brand};
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 500;
    opacity: 1;
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.background};

    &::placeholder {
      opacity: 0.8 !important;
    }
  }
`

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media screen and (min-width: 768px) {
    gap: 1.5rem;
  }
`

export const ButtonWrapper = styled.div`
  width: 4.4rem;
  height: 4.4rem;

  & > button {
    width: 4.4rem;
    height: 4.4rem;
  }
`
